import { c as _c } from "react/compiler-runtime";
import { useMyEvents } from 'modules/calendar/events/hooks/use-my-events';
import { useCommunities } from 'modules/commutinies/hooks/use-communities';
import { useCourseBundlesListAll } from 'modules/courses/bundles/hooks/use-course-bundlies-list-all';
import { coursesDependencies } from 'modules/courses/constants/courses-dependencies';
import { getModulesListAllPath } from 'modules/courses/courses/api/courses-api';
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum';
import { useTagsAll } from 'modules/tags/hooks/use-tags-all';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export interface BaseApiInterface {
  hasMore: boolean;
  items: {
    id: number;
    name: string;
  }[];
}
export interface ListingBaseDataInterface {
  id: number;
  caption: string;
}
export interface UseDigitalResourcesPropsInterface {
  resourceType?: DigitalResourcesTypeEnum;
  courseId?: number | null;
  courseBundleId?: number | null;
  query?: string;
}
export interface DigitalResourcesDataInterface {
  coursesData?: ListingBaseDataInterface[];
  courseBundlesData?: ListingBaseDataInterface[];
  plansData?: ListingBaseDataInterface[];
  tagsData?: ListingBaseDataInterface[];
  communitiesData?: ListingBaseDataInterface[];
  courseModulesData?: ListingBaseDataInterface[];
  courseBundleCoursesData?: ListingBaseDataInterface[];
  eventsData?: ListingBaseDataInterface[];
}
export const getData = (apiData?: BaseApiInterface): ListingBaseDataInterface[] | undefined => apiData?.items.map(el => ({
  id: el.id,
  caption: el.name
}));
const getSimpleData = (apiData?: BaseApiInterface['items']): ListingBaseDataInterface[] | undefined => apiData?.map(el => ({
  id: el.id,
  caption: el.name
}));
export function useDigitalResources(t0) {
  const $ = _c(42);
  const {
    resourceType,
    courseId,
    courseBundleId,
    query
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    fetcher: simpleFetcher
  } = useFetch(t2);
  let t3;
  if ($[2] !== query || $[3] !== resourceType || $[4] !== user) {
    t3 = () => {
      if (user && resourceType === DigitalResourcesTypeEnum.membership_course) {
        return [`/api/dashboard/customer/membership/courses/list-all?active=true${query ? `&${query}` : ""}`, RequestModuleEnum.MembershipCourse];
      }
      return null;
    };
    $[2] = query;
    $[3] = resourceType;
    $[4] = user;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: coursesData
  } = useControlledSwr(t3, fetcher);
  let t4;
  if ($[6] !== courseId || $[7] !== resourceType || $[8] !== user) {
    t4 = () => {
      if (user && resourceType === DigitalResourcesTypeEnum.membership_course && courseId) {
        return [getModulesListAllPath(courseId), RequestModuleEnum.MembershipCourseCurriculum];
      }
      return null;
    };
    $[6] = courseId;
    $[7] = resourceType;
    $[8] = user;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data: courseModulesData
  } = useControlledSwr(t4, simpleFetcher);
  const {
    courseBundlesListAll
  } = useCourseBundlesListAll(resourceType === DigitalResourcesTypeEnum.membership_course_bundle);
  let t5;
  if ($[10] !== courseBundleId || $[11] !== resourceType || $[12] !== user) {
    t5 = () => {
      if (user && resourceType === DigitalResourcesTypeEnum.membership_course_bundle && courseBundleId) {
        return [`/api/dashboard/customer/membership/course-bundles/${courseBundleId}/courses/list-all`, ...coursesDependencies];
      }
      return null;
    };
    $[10] = courseBundleId;
    $[11] = resourceType;
    $[12] = user;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const {
    data: courseBundleCoursesData
  } = useControlledSwr(t5, simpleFetcher);
  let t6;
  if ($[14] !== resourceType || $[15] !== user) {
    t6 = () => {
      if (user && resourceType === DigitalResourcesTypeEnum.systemeio_plan) {
        return "/api/dashboard/customer/user-plans/list/auto-upgrade";
      }
      return null;
    };
    $[14] = resourceType;
    $[15] = user;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const {
    data: plansData
  } = useSWR(t6, fetcher);
  const {
    tags: tagsData
  } = useTagsAll(resourceType === DigitalResourcesTypeEnum.systemeio_tag);
  const {
    data: communitiesData
  } = useCommunities(resourceType === DigitalResourcesTypeEnum.community_access);
  const {
    myEvents: eventsData
  } = useMyEvents(resourceType === DigitalResourcesTypeEnum.booking_event);
  let t7;
  if ($[17] !== coursesData) {
    t7 = getData(coursesData);
    $[17] = coursesData;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== courseBundlesListAll) {
    t8 = getData(courseBundlesListAll);
    $[19] = courseBundlesListAll;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== plansData) {
    t9 = getData(plansData);
    $[21] = plansData;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== tagsData) {
    t10 = getData(tagsData);
    $[23] = tagsData;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== communitiesData) {
    t11 = getSimpleData(communitiesData);
    $[25] = communitiesData;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== courseModulesData) {
    t12 = getSimpleData(courseModulesData);
    $[27] = courseModulesData;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== courseBundleCoursesData) {
    t13 = getSimpleData(courseBundleCoursesData);
    $[29] = courseBundleCoursesData;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== eventsData) {
    t14 = getSimpleData(eventsData);
    $[31] = eventsData;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
    t15 = {
      coursesData: t7,
      courseBundlesData: t8,
      plansData: t9,
      tagsData: t10,
      communitiesData: t11,
      courseModulesData: t12,
      courseBundleCoursesData: t13,
      eventsData: t14
    };
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t7;
    $[39] = t8;
    $[40] = t9;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
}